// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getAuth} from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJ45kUjjVrS1WyJJj79_gK5yHuVr8iuts",
  authDomain: "removebg-e9941.firebaseapp.com",
  projectId: "removebg-e9941",
  storageBucket: "removebg-e9941.appspot.com",
  messagingSenderId: "386964727405",
  appId: "1:386964727405:web:c653d0adf91c7b808b8164",
  measurementId: "G-QSCKLC4QNG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
